module.exports = __webpack_public_path__ + "static/media/download.c00f5779.png";